import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import {FcGoogle} from 'react-icons/fc'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect } from 'react';

const Login = () => {
	const [user, setUser] = useState({
		email: '',
		password: '',
	});

  const [error, setError] = useState()

	const { login, loginWithGoogle, resetPassword } = useAuth();
  const navigate = useNavigate()

	const handleChange = (evt) => {
		const { target } = evt;
		setUser((prevUser) => {
			return {
				...prevUser,
				[target.name]: target.value,
			};
		});
	};

  useEffect(() =>{
    error && toast.error(error, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      });
  },[error])

	const handleSubmit = async (evt) => {
		evt.preventDefault();
    setError('')
    try {
      await login(user.email, user.password);
      navigate('/')
    } catch (err) {
      if(err.code === 'auth/internal-error'){
        setError('Correo Invalido')
      } else if (err.code === 'auth/weak-password'){
        setError('La contraseña debe ser de almenos 6 caracteres')
      } else{
        setError(err.message)
      }
      
    }
	};

  const handleGoogleSignIn = async () => {
    try {
      await loginWithGoogle()
      navigate('/')
    } catch (error) {
      setError(error.message)
    }
  }

  const handleResetPassword = async() =>{
    if(!user.email) return setError('Porfavor ingresa un email')

    try {
      await resetPassword(user.email)
      toast.info('Te hemos enviado un link a tu correo para reestablecer tu contraseña!', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        });
    } catch (err) {
      setError(err.message)
    }
  }

	return (
		<div className='flex items-center justify-center min-h-screen'>
      <div className='w-full max-w-xs m-auto'>
        <h1 className='mb-5 text-4xl font-semibold text-center'>TecnoClothes</h1>
            <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              />
      
            <form onSubmit={handleSubmit} className='px-4 py-6 space-y-2 bg-white border rounded-md'>
        <div className='flex flex-col mb-5 space-y-2'>
              <label htmlFor="email" className='font-bold '>Email</label>
              <input
                type="email"
                name="email"
                placeholder="example@company.com"
                onChange={handleChange}
                className='p-2 border rounded border-slate-500'
              />
            </div>
        <div className='flex flex-col mb-5 space-y-2'>
              <label htmlFor="password" className='font-bold '>Contraseña</label>
              <input
                type="password"
                name="password"
                id="password"
                placeholder='******'
                onChange={handleChange}
                className='p-2 border rounded border-slate-500'
              />
            </div>

        <div className="flex items-center justify-between pt-5">
          <button className='btn-primary'>Ingresar</button>
          <a href="#!"
            onClick={handleResetPassword}
            className=' font-semibold underline hover:opacity-90'
            >Olvidaste tu contraseña?</a>
        </div>
      </form>
      
          <p className='flex justify-between mt-5 font-bold'>No tienes una cuenta? <Link to='/register'> Registrarse</Link></p>
      
          <button onClick={handleGoogleSignIn} className='flex items-center justify-center w-full gap-4 mt-5 btn-primary'>
            <FcGoogle />
            Ingresar con Google
          </button>
          </div>
    </div>
	);
};

export default Login;
